import { FaLayerGroup } from "react-icons/fa";
import "./FieldsSection4.css";

const fieldsData = [
  {
    id: "chung-chi-huong-dan-vien-du-lich",
    title: " hướng dẫn viên du lịch",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field1.webp",
  },
  {
    id: "chung-chi-quan-ly-lu-hanh",
    title: " quản lý lữ hành",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field2.webp",
  },
  {
    id: "chung-chi-du-lich-ben-vung",
    title: " du lịch bền vững",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field3.webp",
  },
  {
    id: "chung-chi-marketing-du-lich",
    title: " marketing du lịch",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field4.webp",
  },
  {
    id: "chung-chi-quan-ly-nha-hang",
    title: " quản lý nhà hàng",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field5.webp",
  },
  {
    id: "chung-chi-dau-bep-chuyen-nghiep",
    title: " đầu bếp chuyên nghiệp",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field6.webp",
  },
  {
    id: "chung-chi-pha-che",
    title: " pha chế",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field7.webp",
  },
  {
    id: "chung-chi-dich-vu-ban-phuc-vu",
    title: " dịch vụ bàn & phục vụ",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field8.webp",
  },
  {
    id: "chung-chi-quan-ly-khach-san",
    title: " quản lý khách sạn",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field9.webp",
  },
  {
    id: "chung-chi-le-tan-khach-san",
    title: " lễ tân khách sạn",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field10.webp",
  },
  {
    id: "chung-chi-quan-ly-buong-phong",
    title: " quản lý buồng phòng",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field11.webp",
  },
  {
    id: "chung-chi-quan-ly-su-kien-trong-khach-san",
    title: " quản lý sự kiện trong khách sạn",
    image: "/images/home/fields/du-lich-nha-hang-khach-san/field12.webp",
  },
];

const FieldsSection = () => {
  return (
    <section className="fields--s4">
      <div className="fields__container">
        <div className="fields__icon">
          <FaLayerGroup />
        </div>
        <p className="fields__sub-title">ĐÀO TẠO CHỨNG CHỈ QUỐC GIA</p>
        <h2 className="fields__title">
          Lĩnh vực du lịch - nhà hàng - khách sạn
        </h2>

        <div className="fields__cards">
          {fieldsData.map((field) => (
            <div
              key={field.id}
              className="field-card"
              id={field.id}
            >
              <div className="field-card__image">
                <img
                  src={field.image}
                  alt={field.title.replace(/\n/g, " ")}
                  loading="lazy"
                />
              </div>
              <h3 className="field-card__title--v3">
                {field.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    {i !== field.title.split("\n").length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldsSection;
